import qs from 'qs';

import { client } from '../client';
import { IListCases, IListCasesParams } from './listAllCases';

export const listCareAdvisorCases = async (params?: IListCasesParams | string): Promise<IListCases> => {
  let queryString = '';
  if (params && typeof params === 'object' && params instanceof Object) {
    queryString = `?${qs.stringify(params, { skipNulls: true })}`;
  } else if (params && typeof params === 'string') {
    queryString = `?${params}`;
  }
  const { data } = await client.get(`/care_advisor/cases${queryString}`);
  return data;
};
